export const Benefits = {
  FREE_HIRE_CAR: 'freehirecar',
  WINDSCREEN: 'windscreen',
};
